import React, { useState, useEffect, useRef } from 'react';
import { NavbarLinks } from '@/constants/navbar';
import { ChevronRight, Mail, PhoneCallIcon, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const NavbarMobileViewSidebar = ({ isOpen, setIsOpen }) => {
  const [currentOpen, setCurrentOpen] = useState([]);
  const sidebarRef = useRef(null); // 👈 for click outside detection

  const handleToggle = (index) => {
    setCurrentOpen((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  // ✅ Auto close when screen width >= 1024 (lg)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsOpen]);

  // ✅ Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setIsOpen]);
  let navigate = useNavigate();
  return (
    <div
      ref={sidebarRef}
      className={`fixed w-[33rem] overflow-y-auto bg-white px-[2rem] py-[2.5rem] ${
        isOpen ? 'right-0' : '-right-[33rem]'
      } top-0 z-50 h-full shadow-lg transition-all duration-300 ease-in-out`}
    >
      <div className="flex w-full flex-wrap items-center justify-end">
        <X
          onClick={() => setIsOpen(false)}
          className="h-[2rem] w-[2rem] cursor-pointer text-[#ff8c00]"
        />

        <div className="mt-[2rem] w-full">
          {NavbarLinks.map((item, index) => {
            const isActive = currentOpen.includes(index);
            return (
              <div key={index} className="w-full font-inter text-[1.4rem]">
                <div
                  className={`flex w-full cursor-pointer items-center justify-between gap-[4rem] ${
                    index + 1 !== NavbarLinks.length && 'border-b'
                  } border-[#D3D8E2] py-[0.6rem]`}
                  onClick={() => handleToggle(index)}
                >
                  <p
                    className="font-[500]"
                    onClick={() => {
                      if (item.link) {
                        navigate(item.link);
                        setIsOpen(false);
                      }
                    }}
                  >
                    {item.label}
                  </p>
                  {item.sublinks && (
                    <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-[0.1rem] bg-[#e24e1f] transition-transform duration-300">
                      <ChevronRight
                        strokeWidth={4}
                        className={`h-[1.1rem] w-[0.9rem] transform text-white transition-transform duration-300 ${
                          isActive ? 'rotate-90' : ''
                        }`}
                      />
                    </div>
                  )}
                </div>

                {item.sublinks && isActive && (
                  <div className="ml-[1rem] flex w-full flex-col bg-white">
                    {item.sublinks.map((item2, index2) => (
                      <p
                        onClick={() => {
                          if (item2.link) navigate(item2.link);
                        }}
                        key={index2}
                        className="cursor-pointer border-b border-[#D3D8E2] px-[0.6rem] py-[0.6rem] text-[1.4rem] font-[500]"
                      >
                        {item2.label}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            );
          })}

          <div className="mt-[2rem] flex flex-row flex-wrap items-center justify-start gap-[1rem]">
            <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-full bg-orange-500">
              <PhoneCallIcon size={'1.4rem'} className="text-white" />
            </div>
            <div className="flex flex-col gap-[0.2rem] text-[1.6rem] text-[#666666]">
              <p className="text-[1.6rem] font-[600]">07454-926-222</p>
            </div>
          </div>

          <div className="mt-[1rem] flex flex-row flex-wrap items-center justify-start gap-[1rem]">
            <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-full bg-orange-500">
              <Mail size={'1.4rem'} className="text-white" />
            </div>
            <div className="flex flex-col gap-[0.2rem] text-[1.6rem] text-[#666666]">
              <p className="text-[1.6rem] font-[600]">office@kucontractors.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
